<template>
  <div>
    <div v-if="!stepSelectBranch" id="crm-home-page">
      <div v-if="guideChangeBranch && !storageGuideChangeBranch" class="guide-change-branch" @click="closegGuideChangeBranch()">
        <div class="crm-main-logo">
          <img
            class="crm-main-logo-img"
            :src="`${this.crm_public_path}${restaurantInfo.logoImgKey}`"
            @click="closegGuideChangeBranch()"
          />
          <div class="crm-main-name px-4" @click="onClickSwitchBranch(); closegGuideChangeBranch()">
            <p class="crm-restaurant-name text-1-line ma-0" @click="closegGuideChangeBranch()">
              {{ restaurantInfo.restaurantName }}
            </p>
            <div style="max-width: calc(100% - 20px);">
              <el-tooltip :manual="true" :value="true" :content="$t('branch.change-branch')" placement="bottom-start" effect="light" popper-class="pink-crm-tooltip">
                <div class="d-flex buble-crm-name mt-3">
                  <span class="crm-branch-name text-1-line ma-0">
                  {{ $t('components.home.branches') }} {{ branchInfo.branchName }}
                  </span>
                  <svg-arrow-down-circle class="crm-arrow-down-circle ml-2" />
                </div>
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
      <main-header-form>
        <PromotionList />
      </main-header-form>
      <earn-points-from-bill v-if="isShowEarnPointsFromBill" />
      <reward-point-promotion v-if="dialogRewardPoint" />
      <branch-list
        :visible="showDrawerSwitchBranch"
        @onCloseDrawerSwitchBranch="onCloseDrawerSwitchBranch"
      />
    </div>
    <link-tree v-else-if="!haveBranch && stepSelectBranch" :stepSelectBranch="stepSelectBranch" @redirectFunction="redirectFunction"></link-tree>
    <el-dialog
      :visible.sync="dialogGuideChange"
      width="70%"
      @closed="closDialogGuideChange"
    >
      <div class="flex-column-center">
        <lottie-player
          src="https://lottie.host/c8746c45-de6f-4b74-a62c-7d066eee2987/HhION63VBS.json"
          background="transparent"
          speed="1"
          style="height: 140px;"
          loop
          autoplay
        ></lottie-player>
        <span class="head-topic">{{ $t("branch.welcome-branch") }} <br> {{ branchInfo.branchName }}</span>
        <span class="descropt-topic">{{ $t("branch.want-change-branch") }}</span>
        <div style="display: flex;width: 100%; margin-top: 16px;">
          <el-button class="crm-white-btn" @click="onClickSwitchBranch(); dialogGuideChange = false "> {{ $t("branch.another-branch") }} </el-button>
          <el-button class="crm-blue-btn text-over" @click="dialogGuideChange = false"> {{ $t("branch.stay-this-branch") }}</el-button>
        </div>
        <el-divider style="margin: 24px 0 12px;"></el-divider>
        <div style="text-align: start; width: -webkit-fill-available;">
          <el-checkbox class="not-show-agin" v-model="checkedCloseGuideDialog">{{ $t("branch.not-show-again")}}</el-checkbox>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import MainHeaderForm from "@/components/home/MainHeaderForm";
import PromotionList from "@/components/promotion/PromotionList";
import EarnPointsFromBill from "@/components/home/EarnPointsFromBill";
import rewardPointPromotion from "@/components/home/rewardPointPromotion";
import { mapActions, mapGetters, mapMutations } from "vuex";
import GATracking from "@/helper/GATrackingMixins";
import linkTree from '@components/elements/linktree.vue';
const BranchList = () => import("@/components/home/BranchList.vue");
const SvgArrowDownCircle = () => import("@/assets/svg/arrow-down-circle.svg");

export default {
  components: {
    MainHeaderForm,
    PromotionList,
    EarnPointsFromBill,
    linkTree,
    BranchList,
    SvgArrowDownCircle,
    rewardPointPromotion
  },
  data() {
    return {
      crm_public_path: process.env.VUE_APP_S3_PUBLIC_PATH,
      haveBranch : false,
      stepSelectBranch : false,
      showDrawerSwitchBranch : false,
      guideChangeBranch: false,
      dialogGuideChange: false,
      checkedCloseGuideDialog: false,
      storageGuideChangeBranch : false
    };
  },
  mixins: [GATracking],
  mounted() {
    //เปิดหน้าเลือกสาขากรณี เข้ามาด้วนลิ้งร้าน ไม่มีสาขา
    if( !this.branchUUID ){
      this.haveBranch = (this.branchUUID != null) && (this.branchUUID != 'null') ? true : false
      this.stepSelectBranch = true
    }
    else{
      // ถ้าจะเขียนอะไรใน mounted เขียนใน funcInsteadMounted() นะคะ
      this.stepSelectBranch = false
      this.storageGuideChangeBranch = localStorage['guide-Change-branch']
      this.funcInsteadMounted()
    }
    //แสดง banner ใหม่ทุกครั้งที่ มาที่หน้า home และตรงเงือนไข 
    if( this.restaurantInfo.channelID && this.userInfo && this.userInfo.lineUid == "")
      this.setBannerLine(true)
    
  },
  computed: {
    ...mapGetters({
      restaurantInfo: "restaurant/restaurantInfo",
      restaurantUUID: "restaurant/restaurantUUID",
      branchUUID: "branch/branchUUID",
      branchInfo: "branch/branchInfo",
      uniqueOrderCode: "bill/uniqueOrderCode",
      isShowEarnPointsFromBill: "bill/isShowEarnPointsFromBill",
      feedback: "user/userFeedback",
      userInfo: "user/userInfo",
      promotionRewardPoint : "promotion/promotionRewardPoint",
      dialogRewardPoint : "promotion/dialogRewardPoint"
    }),
  },
  methods: {
    ...mapMutations({
      openEarnPointDialog: "bill/OPEN_EARN_BILL_DIALOG",
      setUOC: "feedback/SET_UOC",
      setBranchFeedback: "feedback/SET_BRANCH",
      setIcon: "feedback/SET_ICON",
      setBannerLine: "restaurant/SET_BANNER_LINE",
      openRewardPiontDialog: 'promotion/OPENT_REWARD_POINT_DIALOG'
    }),
    ...mapActions({
      fetchRestaurantInfo: "restaurant/fetchRestaurantInfo",
      fetchBranchInfo: "branch/fetchBranchInfo",
      fetchUserInfo: "user/fetchUserInfo",
    }),
    openReviewFeedback(){
      this.setBranchFeedback(this.feedback.branch_uuid)
      this.setUOC(this.feedback.uoc)
      this.$router.push({
        name:'feedback',
        params:{uoc:this.feedback.uoc}
      })
    },
    redirectFunction(){
      this.fullscreenLoading = false
      this.$router.push({
        name:'Home',
        params:{
          restaurant_aliase : this.restaurantUUID,
          branch_aliase :  this.branchUUID
        }
      })
      this.stepSelectBranch = false
      this.funcInsteadMounted()
    },
    funcInsteadMounted(){
      this.viewActivity('CRM Promotion List', 'CRMPromotionList', 'tabHomeCRM')
      const dataPointsString = localStorage.getItem('register-points') 
      const registerPoints = dataPointsString ? JSON.parse(dataPointsString) : null
      this.fullscreenLoading = false
      if (this.uniqueOrderCode || (dataPointsString && registerPoints.restaurantUuid === this.restaurantInfo.restaurantUUID)) {
        this.openEarnPointDialog();
      }
      else if(this.promotionRewardPoint){
        this.openRewardPiontDialog();
      }
      else if( !localStorage['dialog-Guide-Change-branch'] )
        this.dialogGuideChange = true
      this.fetchRestaurantInfo(this.restaurantUUID);
      this.fetchBranchInfo(this.branchUUID);
      this.fetchUserInfo().then(async (response) => {
        // ต้องไม่ earn piont อยู่
        if ( !this.uniqueOrderCode ) {
          let stopReview = localStorage['stop-review']
          if(!stopReview && response.feedback){
            let lastUOC = localStorage['crm-review-feedback']
            let feedbackRound = localStorage['feedback-round']

            if( lastUOC != response.feedback.uoc && !response.feedback.review ) {
              localStorage.setItem('crm-review-feedback', response.feedback.uoc)
              localStorage.setItem('feedback-round', 1)
              this.setIcon(false)
              this.openReviewFeedback()
            }
            else if( (lastUOC == response.feedback.uoc && feedbackRound < 2) && !response.feedback.review ){
              localStorage.setItem('feedback-round', ++feedbackRound )
              this.setIcon(true)
              this.openReviewFeedback()
            }
            else if(response.feedback.review){
              localStorage.setItem('feedback-round', 1)
            }
          }else{
            localStorage.removeItem('stop-review')
          }
        }
      })
    },
    onClickSwitchBranch() {
      this.trackActivity(3, 'CRMPromotionList');
      this.showDrawerSwitchBranch = true;
      this.guideChangeBranch = false
    },
    onCloseDrawerSwitchBranch() {
      this.showDrawerSwitchBranch = false;
    },
    closDialogGuideChange(){
      if(this.checkedCloseGuideDialog){
        localStorage.setItem('dialog-Guide-Change-branch', false)
      }
      if(this.showDrawerSwitchBranch == false){
        this.guideChangeBranch = true
      }
    },
    closegGuideChangeBranch(){
      localStorage.setItem('guide-Change-branch', true)
      this.guideChangeBranch = false
    }
  },
};
</script>
<style scoped>
.guide-change-branch{
  position: absolute;
  z-index: 10;
  width: var(--max-width-app);
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(3px);
}
.crm-main-logo {
  padding-top: 35px;
  font-weight: bold;
  font-size: 24px;
  line-height: 16px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  color: #ffffff;
}
.crm-main-logo-img {
  text-align: center;
  border: 1px solid #ffffff;
  border-radius: 50%;
  margin-left: 28px;
  width: 60px;
  height: 60px;
}
.crm-main-name {
  width: calc(100% - 190px);
  box-sizing: border-box;
}
.crm-restaurant-name {
  font-size: 24px;
  font-weight: 500;
  line-height: 16px;
}
.buble-crm-name{
  background: rgba(255, 255, 255, 0.4);
  border-radius: 39px;
  padding: 4px 8px;
  width: min-content;
  max-width: calc(100% - 20px);
}
.crm-branch-name {
  max-width: calc(100% - 20px);
  font-size: 14px;
  font-weight: lighter;
  line-height: 16px;
}
.not-show-agin{
  font-size: 18px;
  color: #C7C7C7;
  text-align: start;
}
</style>
<style>
/* tooltip */
.el-tooltip__popper.is-light.pink-crm-tooltip{
    background: #FF4094;
    color: #FFF;
    border: 0;
    border-radius: 9px;
    font-size: 14px;
    padding: 5px 12px;
}
.el-tooltip__popper.is-light[x-placement^=bottom].pink-crm-tooltip .popper__arrow::after {
  border-bottom-color: #FF4094;
}

/* dialog */
.head-topic{
    font-weight: 500;
    font-size: 24px;
    color: #333333;
    text-align: center;
    margin-bottom: 8px;
}
.descropt-topic{
    color: #4F4F4F;
    font-weight: 400;
    font-size: 20px;
    text-align: center;
}
.crm-blue-btn{
    padding: 7px 14px;
    height: 40px;
    border-radius: 10px;
    font-size: 20px;
    color: #FFFFFF !important;
    background: #28B7FF;
    border: 1px solid #28B7FF;
}
.crm-white-btn{
    padding: 7px 14px;
    height: 40px;
    border-radius: 10px;
    font-size: 20px;
    color: #28B7FF !important;
    background: #fff;
    border: 1px solid #28B7FF;
}
.el-button:focus.crm-blue-btn,.el-button:hover.crm-blue-btn{
  color: #28B7FF !important;
}
.el-button.crm-blue-btn ,.el-button.crm-white-btn {
  font-family: 'DB Heavent';
  width: 100%;
}
.flex-column-center{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.el-divider--horizontal{
  margin: 24px 0 12px;
}
.not-show-agin .el-checkbox__label{
  font-size: 18px;
}
.el-dialog__header {
  display: none;
}
.el-dialog__body {
    padding: 30px 20px 24px;
}
</style>
